/**
 * ConversionProgressPage - Document conversion tracking dashboard
 *
 * Surfaces the ConversionProgressDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides real-time tracking of chaos-to-DSL document conversion jobs.
 *
 * Route: /admin/conversion-progress
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconTransform } from '@tabler/icons-react';

import { ConversionProgressDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';
import { useSearchParams } from 'react-router-dom';

export function ConversionProgressPage() {
  const { tenant } = useAuth();
  const [searchParams] = useSearchParams();
  const extractionId = searchParams.get('extractionId') ?? 'demo';

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="orange">
            <IconTransform size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Conversion Progress</Title>
            <Text size="sm" c="dimmed">
              Track document-to-DSL conversion jobs and extraction results
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <ConversionProgressDashboard extractionId={extractionId} tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default ConversionProgressPage;
